import { RSCImage } from 'react-datocms';
import { CdaStructuredTextRecord } from 'react-datocms/structured-text';
import InlineRichText from 'components/RichContent/InlineRichText';
import { ResponsiveImage } from 'services/graphql';

import styles from './TestimonialBlock.module.css';

interface TestimonialBlockRecord extends CdaStructuredTextRecord {
  person: {
    image?: ResponsiveImage;
    title: string;
    subtitle?: string;
  };
  quote: string;
}

export default function TestimonialBlock({ quote, person }: TestimonialBlockRecord) {
  return (
    <figure
      className={styles.container}
      itemScope
      itemType="https://schema.org/Review"
    >
      <blockquote
        className={styles.quote}
        itemProp="reviewBody"
      >
        <InlineRichText as="p">{quote}</InlineRichText>
        {person.image?.responsiveImage && (
          <RSCImage
            pictureClassName={styles.image}
            data={person.image?.responsiveImage}
          />
        )}
      </blockquote>
      <figcaption
        className={styles.caption}
        itemProp="author"
        itemScope
        itemType="https://schema.org/Person"
      >
        <div
          className={styles.name}
          itemProp="name"
        >
          {person.title}
        </div>
        <div itemProp="roleName">{person.subtitle}</div>
      </figcaption>
    </figure>
  );
}
